import { authHeader } from "@/_helpers/auth-header";
import { handleResponse } from "@/_helpers/handle-response";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_ITTENTION;

export const userService = {
  login,
  getAll,
  postlogout,
  getlogout,
  getProfile,
  getUser,
  updateProfil,
  updateUser,
  consom
};

function login(username, password) {
  const requestOptions = {
    method: "post",
    url: "/auth/login/",
    data: {
      username: username,
      email: "",
      password: password
    }
  };
  return axios(requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}

function postlogout() {
  const requestOptions = {
    method: "post",
    url: "/auth/logout/"
  };
  return axios(requestOptions).then(handleResponse);
  // remove user from local storage to log user out
}

function getlogout() {
  const requestOptions = {
    method: "get",
    url: "/auth/logout/"
  };
  return axios(requestOptions).then(handleResponse);
  // remove user from local storage to log user out
}

function getAll() {
  const requestOptions = {
    method: "get",
    url: "/auth/user/",
    headers: authHeader()
  };
  return axios(requestOptions).then(handleResponse);
}

function getProfile(uuid) {
  const requestOptions = {
    method: "get",
    url: "/accounts/api/v1/userprofile",
    headers: {
      Authorization: authHeader().Authorization,
    }
  }
  return axios(requestOptions);
}
function updateProfil(datas) {
  const requestOptions = {
    method: "patch",
    url: "/accounts/api/v1/userprofile/" + datas.uuid + "/",
    data: datas,
    headers: {
      Authorization: authHeader().Authorization
    }
  }
  return axios(requestOptions);
}
function consom() {
  const requestOptions = {
    method: "get",
    url: "/processes/api/v1/monthlyentries/",
    headers: {
      Authorization: authHeader().Authorization
    }
  }
  return axios(requestOptions);
}
function getUser(uuid) {
  const requestOptions = {
    method: "get",
    url: "/auth/user/",
    headers: {
      Authorization: authHeader().Authorization,
    }
  }
  return axios(requestOptions);
}
function updateUser(datas) {
  const requestOptions = {
    method: "patch",
    url: "/auth/user/",
    data: datas,
    headers: {
      Authorization: authHeader().Authorization
    }
  }
  return axios(requestOptions);
}